import 'unfetch/polyfill';

import { setImmutableEditingData } from "./editing";
import { applyFilters, setImmutableFilteringData } from "./filtering";
import { setAppInitialized } from "./loading";
import { setImmutableSearchingData } from "./searching";
import { addErrorMessage, addSuccessMessage } from "./messaging";
import { setImmutableInterfaceData } from "./interface";

export const SET_IMMUTABLE_APP_DATA = 'SET_IMMUTABLE_APP_DATA';
export const SET_ROW_DATA = 'SET_ROW_DATA';
export const UPDATE_ROW_DATA = 'UPDATE_ROW_DATA';


export function fetchAppData(endpoint) {

    return (dispatch) => {
        fetch(endpoint, {
            headers: {'X-Requested-With': 'XMLHttpRequest'},
            credentials: 'same-origin'
        })
        .then((response) => {
            if (response.status === 200) {
                return response.json();
            }
        })
        .then(json => dispatch( loadAppData(json) ))
        .then(() => dispatch( setAppInitialized() ))
    }

}

export function loadAppData (appData) {

    return (dispatch) => {
        return new Promise(function (resolve, reject) {

            const { messages } = appData;
            const { fields, field_types: fieldTypes, field_widths: fieldWidths, rows, row_keys: rowKeys,
                value_formatter_mappings: valueFormatterMapping, filter_download_url: filterDownloadUrl } = appData;
            const { filtering } = appData;
            const { searching } = appData;
            const { editing } = appData;

            // messages from the server.
            const { success: successMessages, error: errorMessages } = messages;
            if ( successMessages !== undefined ) {
                successMessages.forEach((item) => {
                    dispatch( addSuccessMessage(item.heading, item.content) )
                })
            }
            if ( errorMessages !== undefined ) {
                errorMessages.forEach((item) => {
                    dispatch( addErrorMessage(item.heading, item.content) )
                })
            }

            // base data that will always be sent from the server.
            dispatch( setImmutableAppData(fields, fieldTypes, fieldWidths, rowKeys, valueFormatterMapping,
                filterDownloadUrl) );
            dispatch( setRowData(rows) );

            // conditionally load editing data which may or may not be sent from the server.
            if ( editing ) {
                const { editing_enabled: editingEnabled, can_add_rows: canAddRows, can_delete_rows: canDeleteRows,
                    fields, row_keys: rowKeys, defaults, options, input_properties: inputProperties } = editing;
                dispatch( setImmutableEditingData(editingEnabled, canAddRows, canDeleteRows, fields, rowKeys,
                    defaults, options, inputProperties) )
            }

            // conditionally load filtering data which may or may not be sent from the server.
            if ( filtering ) {
                const { fields, options } = filtering;
                dispatch( setImmutableFilteringData(fields, options) )
            }

            // conditionally load searching data which may or may not be sent from the server.
            if ( searching ) {
                const { fields, search_index: searchIndex } = searching;
                dispatch( setImmutableSearchingData(fields, searchIndex) )
            }

            // Set interface data
            let numTableColumns = Object.keys(fields).length;
            numTableColumns = editing && editing.editing_enabled ? numTableColumns + 1 : numTableColumns;
            dispatch( setImmutableInterfaceData(numTableColumns) );

            resolve()
        })
        .then(() => dispatch( applyFilters() ))  // we just loaded data so we need to apply any filters to it.
    }
}

function setImmutableAppData(fields, fieldTypes, fieldWidths, rowKeys, valueFormatterMapping, filterDownloadUrl) {
    return {
        type: SET_IMMUTABLE_APP_DATA,
        fields,
        fieldTypes,
        fieldWidths,
        rowKeys,
        valueFormatterMapping,
        filterDownloadUrl,
    }
}

function setRowData(rows) {
    // should only be called once at app load.
    return {
        type: SET_ROW_DATA,
        rows,
    }
}

export function updateRowData(rowKey, field, value) {
    return {
        type: UPDATE_ROW_DATA,
        rowKey,
        field,
        value,
    }
}
